const isProd = process.env.NODE_ENV === "production";

const config = {
  apiUrl: isProd
    ? process.env.REACT_APP_PROD_API_URL
    : process.env.REACT_APP_API_URL,

  siteUrl: isProd
    ? process.env.REACT_APP_PROD_SITE_URL
    : process.env.REACT_APP_SITE_URL,
};

export default config;
